import rating from 'iz-ds-neo-alt/dist/system/i18n/jp/rating'

export default {
  ...rating,
  MSG_SEND_LOADING: 'システムへ送信しています。',
	MSG_SEND_SUCCESS: 'システムはご意見を受け取りました。',
}